//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import FeatureContainer from '~/components/forCompanies/FeatureContainer.vue'
import DescriptionCard from '~/components/forGaming/DescriptionCard.vue'
// import AnimatedLink from '~/components/common/AnimatedLink.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    FeatureContainer,
    DescriptionCard
    // AnimatedLink
  },
  data () {
    return {
      block6: {
        1: {
          link: '/solutions',
          type: 'internal-link'
        },
        2: {
          link: '/products-services/local-payments',
          type: 'external-link'
        },
        3: {
          link: 'https://www.transfersmile.com/',
          type: 'external-link'
        },
        4: {
          link: 'https://wallet.pagsmile.com/',
          type: 'external-link'
        },
        5: {
          link: 'https://linkme.live/',
          type: 'external-link'
        }
      },
      block7: {
        1: {
          link: 'https://www.terra.com.br/amp/noticias/dino/fusoes-e-aquisicoes-empresariais-apresentam-queda-em-relacao-a-anos-anteriores,8f4138fdf19eecc4c864b3f316836fd4guauhevp.html',
          type: 'external-link'
        },
        2: {
          link: 'https://www.techtudo.com.br/google/amp/dicas-e-tutoriais/2021/01/pagsmile-no-free-fire-como-comprar-diamantes-mais-baratos-na-recarga-esports.ghtml',
          type: 'external-link'
        },
        3: {
          link: 'https://www.segs.com.br/seguros/295184-facilitadoras-de-pagamento-como-empresas-deste-segmento-aproximam-o-cliente-final-e-o-produto-desejado/amp',
          type: 'external-link'
        }
      }
    }
  },
  head () {
    return {
      title: this.$t('footer.about.about').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
